import { useParams } from "react-router-dom";
import ExtendProduct from "./ExtendProduct";

export const ShowProduct = () => {
  const { id } = useParams();

  return <ExtendProduct row={{ id, onUpdate: () => {}, onDelete: () => {} }} />;
};
